import { Chip } from "@mui/material";
import { required } from "react-admin";
import { TextArrayInput } from "./TextArrayInput";
import { isEmailValid } from "./utils";

export const TextArrayEmailInput = ({ isRequired = false, source }: any) => {
  let cookie = localStorage.getItem("PB_Auth");
  let email = "";
  if (cookie) {
    const { id } = JSON.parse(cookie);
    email = id;
  }
  return (
    <TextArrayInput
      source={source}
      label="Emails IDs"
      options={[email]}
      fullWidth
      validate={isRequired ? required() : undefined}
      renderTags={(value: readonly string[], getTagProps) =>
        value.map((option: string, index: number) => {
          const { key, ...tagProps } = getTagProps({ index });

          if (isEmailValid(option)) {
            return <Chip label={option} key={key} {...tagProps} />;
          } else {
            return <Chip label={option} key={key} {...tagProps} color="error" />;
          }
        })
      }
    />
  );
};
